export const InputType = {
  TEXT: "text",
  EMAIL: "email",
  TEL: "tel",
  POSTAL_CODE: "postalCode",
  HIRAGANA: "hiragana",
  KATAKANA: "katakana",
}
export type InputType = typeof InputType[keyof typeof InputType];